import { useTheme } from 'styled-components';

const useThemeColors = () => {
  const theme = useTheme();
  return theme.colors;
};

export { useThemeColors };
//# sourceMappingURL=useThemeColors.js.map
